window.THhWishlistLoaded = true;
console.log("wishlist.js loaded ✅");
document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'thhWishlist';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  // Handle heart clicks
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.thh-save-btn');
    if (!btn) return;

    const handle = btn.dataset.handle;
    if (!handle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      btn.classList.remove('active');
    } else {
      wishlist.push(handle);
      btn.classList.add('active');
    }

    saveWishlist(wishlist);
  });

  // Render wishlist page
  const grid = document.getElementById('thh-wishlist-grid');
  const empty = document.getElementById('thh-wishlist-empty');

  if (grid) {
    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      empty.style.display = 'block';
      return;
    }

    wishlist.forEach(handle => {
      const item = document.createElement('div');
      item.className = 'thh-wishlist-item';
      item.innerHTML = `
        <a href="/products/${handle}">
          View ${handle.replace(/-/g, ' ')}
        </a>
      `;
      grid.appendChild(item);
    });
  }
});